import { Accordion, VStack, Flex, Text } from '@chakra-ui/react'
import { MdSubdirectoryArrowRight } from "react-icons/md";
import { Link } from 'react-router-dom'

const Tree = ({ data }) => {
        return (
          <Accordion.Root multiple collapsible variant={'plain'} p={0} m={0}>
            <Accordion.Item p={0} m={0}>
                {data[0].type == "dir" && (
                    <Accordion.ItemTrigger p={0} m={0}>
                    <Flex  cursor={'pointer'} _hover={{color: '#465362'}} fontSize={20} paddingLeft={2} gap={2} justifyContent={'space-between'}>
                      <MdSubdirectoryArrowRight />
                      {data[0].name}
                    </Flex>
                  </Accordion.ItemTrigger>
                )}
                {data[0].type == "file" && (
                    <Accordion.ItemTrigger p={0} m={0}>
                    <Flex  cursor={'pointer'} _hover={{color: '#465362'}} fontSize={20} paddingLeft={2} gap={2} justifyContent={'space-between'}>     
                        <Link to={'/login'}>
                            <Text color={'#B1BFFF'} _hover={{color: '#465362'}}>{data[0].name}</Text>
                        </Link>  
                    </Flex>
                  </Accordion.ItemTrigger>
                )}
              <Accordion.ItemContent p={0} m={0}>
                <Accordion.ItemBody>
                {data[0].children && data[0].children.length > 0 && data[0].type == 'dir' && (
                  <VStack paddingLeft={4} spacing={2}>
                    {data[0].children.map((child, index) => (
                      <Tree key={index} data={child} />
                    ))}
                  </VStack>
                )}
                {data[0].children.length == 0 && data[0].type == 'file' &&(
                    <Link to={data[0].link}>
                        <Text color={'#B1BFFF'}>id:{data[0].id}</Text>
                        <Text color={'#B1BFFF'}>type:{data[0].type}</Text>
                    </Link>
                )}
                </Accordion.ItemBody>
              </Accordion.ItemContent>
            </Accordion.Item>
          </Accordion.Root>
        );
};
export default Tree;